import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={70}
            height={70}
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect width={70} height={70} rx={35} fill={theme["#0D968F"]} />
        <path
            d="M27.5 47.5a2.468 2.468 0 01-1.765-.699c-.49-.467-.735-1.027-.735-1.682V33.214c0-.654.245-1.215.735-1.682a2.468 2.468 0 011.765-.699h11.25v-2.38c0-.993-.365-1.836-1.094-2.53-.729-.695-1.614-1.042-2.656-1.042-.854 0-1.61.243-2.265.729-.657.486-1.1 1.096-1.329 1.83-.104.298-.265.541-.483.729-.22.189-.475.283-.767.283-.416 0-.75-.134-1-.402s-.333-.57-.25-.907c.313-1.33 1.032-2.436 2.157-3.32C32.188 22.942 33.5 22.5 35 22.5c1.73 0 3.203.58 4.422 1.74 1.219 1.162 1.828 2.566 1.828 4.212v2.381h1.25c.688 0 1.276.233 1.766.7.49.466.734 1.026.734 1.681V45.12c0 .655-.245 1.215-.734 1.682a2.472 2.472 0 01-1.766.699h-15zm7.5-5.952c.688 0 1.276-.233 1.766-.7.49-.466.734-1.027.734-1.681 0-.655-.245-1.216-.734-1.683A2.473 2.473 0 0035 36.786c-.688 0-1.276.233-1.765.698-.49.467-.735 1.028-.735 1.683 0 .654.245 1.215.735 1.682.49.466 1.078.699 1.765.699z"
            fill="#fff"
        />
        </svg>
    )
}
  
  export default SvgComponent